import { dataTrackHost } from '@/config/apis';
import { log } from '@/util/console';
export const getReportUrl = (viewHost: string = dataTrackHost, reportHost: string, sessionId: string) => {
    const loggerUrl = `${viewHost}/#/logger/index?sessionId=${sessionId}`;
    log(`%c埋点抓包校验: %c${loggerUrl}`, 'color:#1abf89;font-size:1.2em;line-height:2.4em;', 'font-size:1.2em;');
    return `${reportHost}/${sessionId}/`;
};